import script from "./SectionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionItem.vue?vue&type=script&setup=true&lang=ts"

import "./SectionItem.vue?vue&type=style&index=0&id=59869d22&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59869d22"]])

export default __exports__